import { render, staticRenderFns } from "./summarybox.vue?vue&type=template&id=6786f0ad&scoped=true&"
import script from "./summarybox.vue?vue&type=script&lang=js&"
export * from "./summarybox.vue?vue&type=script&lang=js&"
import style0 from "./summarybox.vue?vue&type=style&index=0&id=6786f0ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6786f0ad",
  null
  
)

export default component.exports